import { type FC } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";

interface StreamEntrypointsFilterProps {
  onCreate: () => void;
}

/** Карточка фильтра в общем стиле списков: поиск внутри панели. */
export const StreamEntrypointsFilter: FC<StreamEntrypointsFilterProps> = ({
  onCreate,
}) => {
  const { t } = useTranslation();

  return (
    <Filter
      title={t("streamEntrypoints.listTitle")}
      fields={{ search: true }}
      action={
        <Button variant="contained" startIcon={<AddIcon />} onClick={onCreate}>
          {t("streamEntrypoints.createButton")}
        </Button>
      }
    />
  );
};
